import React from 'react'
import {
  Segment, Container, Header, Divider,
  Dimmer, Loader, Message
} from 'semantic-ui-react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import {t} from "../../i18n";
import FormComponent from '../containers/formcomponent';

function mapStateToProps(state) {
  return {
    userRegister: state.userRegister,
  };
}

class Register extends FormComponent {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      passwordVisible: false,
      ...this.state
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userRegister !== this.props.userRegister) {
      let register = this.props.userRegister;
      this.validateForm(register, () => {
        this.setState({
          showSuccess: true,
          loading: false,
          showErrors: false
        });
      })
    }
  }

  callRegister() {
    this.props.actions.userRegister({
      email: this.state.email,
      password: this.state.password,
    });
  }

  render() {
    return (
      <div style={{ minHeight: 'calc(100vh - 240px)', display: 'flex', alignItems: 'center' }}>
        <Container>
          <Segment className="loginSegment" style={{ minWidth: "40%", margin: 'auto' }} basic>
            <Dimmer inverted active={this.state.loading}>
              <Loader content={t("system.loading")} />
            </Dimmer>
            <Header as="h3" textAlign='center'>{t("register.header")}</Header>
            <Divider section />
            <Message>
              {t("register.contactInfo")} <a href="mailto:info@fiberpay.pl">info@fiberpay.pl</a>
            </Message>
          </Segment>
        </Container>
      </div>
    )
  }
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators(actions, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(Register)
